module.exports = __webpack_public_path__ + "img/set.d80fe555.svg";